import { Directive, HostBinding, Input } from '@angular/core';
let nextUniqueId = 0;

@Directive( {
    // selector: '[ridangoHint]',
    // tslint:disable-next-line:directive-selector
    selector: 'ridango-hint',
    // tslint:disable:use-host-property-decorator
    host: {
        'class': 'ridango-hint',
        '[class.ridango-right]': 'align == "end"',
        '[attr.id]': 'id',
        // Remove align attribute to prevent it from interfering with layout.
        '[attr.align]': 'null',
    }
} )
export class HintDirective {
    // TODO: check this
    // @HostBinding( 'class' ) class = 'ridango-hint';
    // @HostBinding( 'class' ) role = 'alert';
    // @HostBinding( '[attr.id]' ) id = `ridango-hint-${nextUniqueId++}`;


    /** Whether to align the hint label at the start or end of the line. */
    @Input() align: 'start' | 'end' = 'start';

    /** Unique ID for the hint. Used for the aria-describedby on the form field control. */
    @Input() id = `ridango-hint-${nextUniqueId++}`;

    constructor() { }

}
